import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer"; 
import ApplicationState from "@insite/client-framework/Store/ApplicationState"; 
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers"; 
import { BudgetBalanceModel } from "@rightstore/Model/BudgetBalance.model";
import { Draft } from "immer";  

type BudgetBalanceState = Readonly<{ 
    isLoading: boolean
    value: BudgetBalanceModel | undefined | null
}>;

const initialState: BudgetBalanceState = { 
    isLoading: false,
    value: undefined
};

 const reducer = {
    "Data/BudgetBalance/BeginLoadBudgetBalance": (draft: Draft<BudgetBalanceState>, action: { parameter: object }) => {
        draft.isLoading = true
    },
    "Data/BudgetBalance/CompleteLoadBudgetBalance": (
        draft: Draft<BudgetBalanceState>,
        action: { parameter: object; model: BudgetBalanceModel | null },
    ) => {
        draft.isLoading = false;
        draft.value = action.model;
    }
};

const budgetBalanceReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).budgetBalance = budgetBalanceReducer;

export type CustomState = { 
    budgetBalance: BudgetBalanceState; 
} & ApplicationState;

type Reducers = { 
    budgetBalance: typeof budgetBalanceReducer; 
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;